var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43954 17.0906C10.8546 17.0906 12.0017 15.9435 12.0017 14.5285C12.0017 13.1134 10.8546 11.9663 9.43954 11.9663C8.0245 11.9663 6.87738 13.1134 6.87738 14.5285C6.87738 15.9435 8.0245 17.0906 9.43954 17.0906Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2611 12.5361C18.6762 12.5361 19.8233 11.389 19.8233 9.97396C19.8233 8.55892 18.6762 7.4118 17.2611 7.4118C15.8461 7.4118 14.699 8.55892 14.699 9.97396C14.699 11.389 15.8461 12.5361 17.2611 12.5361Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2611 21.5603C18.6762 21.5603 19.8233 20.4132 19.8233 18.9981C19.8233 17.5831 18.6762 16.436 17.2611 16.436C15.8461 16.436 14.699 17.5831 14.699 18.9981C14.699 20.4132 15.8461 21.5603 17.2611 21.5603Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09372 13.8461L9.78699 15.0367L17.6085 10.4825L16.9152 9.29188L9.09372 13.8461Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09305 15.0379L16.9146 19.5921L17.6078 18.4015L9.78632 13.8473L9.09305 15.0379Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b6b9e60f8604897c93b061a7cd930683.svg";
export { ForwardRef as ReactComponent };